export const stepsGooglePay = [
  {
    number: 2,
    title: 'Download or open the Google Pay app.',
    description: ''
  },
  {
    number: 3,
    title: 'In the app, tap the plus (+), then select “Payment method.”',
    description: ''
  },
  {
    number: 4,
    title: 'Select “Credit or debit card”, then “Enter data manually.”',
    description: 'Enter your card number, expiry, and CVV on the back of your card.'
  },
  {
    number: 5,
    title: 'Tap “Save,” then “Accept” after reading the terms.',
    description: 'Select SMS as verification method and enter the text code that’s sent.'
  },
  {
    number: 6,
    title: 'Follow all steps to be verified.',
    description: 'Once you enter your SMS code, you’re ready to make payments.'
  }
];

export const stepsApplePay = [
  {
    number: 2,
    title: 'In the Wallet app, tap the plus (+).',
    description:
      'Make sure you’re signed into an Apple device that uses iOS, iPadOS, watchOS, or macOS.'
  },
  {
    number: 3,
    title: 'Tap “Debit or Credit Card” to add your debit card.',
    description: 'You can use your camera or add your card details manually.'
  },
  {
    number: 4,
    title: 'Follow all steps to be verified.',
    description: 'You may need to provide more info or download an app.'
  }
];

export const APPLE_WALLET_TAB = '1';
export const GOOGLE_PAY_TAB = '2';
